import classnames from "classnames";
import Popover from "component/design-system/popover/Popover";
import { useTranslation } from "next-i18next";
import { cloneElement } from "react";
import HideIf from "util/HideIf";
import { toKebabCase } from "util/lodash/toKebabCase";
import { getProductHeading } from "util/product/get-product-heading";
import { UI_LABEL } from "./constants";
import { needPopOver } from "./ExtendedDescriptionPopover";
import UI_VALUE from "./ExtendedDescriptionValue";
import styles from "./tireProduct-extended-definition.style.module.scss";

const DISPLAY_ORDERS = [
  "season", "speedRating", "widthInMm", "loadIndex",
  "size", "series", "offset", "surfaceFinish", "model",
];

function sortOrder(a: any, b: any) {
  return DISPLAY_ORDERS.indexOf(a) - DISPLAY_ORDERS.indexOf(b);
}

function ExtendedDescription(props: any) {
  const {
    extendedDescription, style, showTopSeparator = false, description = null, descriptions = null, showHeading = false, manufacturer = null,
    partNumber = null, className = "", specClassName = "", quantity, tier3, accordionColor, sliceInfo,
  } = props;

  const extendedInfo = { ...extendedDescription };
  const { t } = useTranslation("category");

  const h1Text = getProductHeading({
    manufacturer, description, partNumber, extendedDescription,
  });
  const h1 = showHeading ? h1Text : null;

  let renderInfo = Object.keys(extendedInfo)
    .filter((_) => UI_LABEL[_] && extendedInfo[_])
    .sort(sortOrder)
    .map((_) => ({
      label: `${t(UI_LABEL[_])} :`,
      value: UI_VALUE[_] ? cloneElement(UI_VALUE[_], { ...extendedInfo }) : extendedInfo[_],
      hasInfo: needPopOver(_),
    }));

  if (quantity && renderInfo.length === 0) {
    return <li>{`${quantity} pcs - ${h1Text}`}</li>;
  }

  if (renderInfo.length === 0) {
    return null;
  }

  if (sliceInfo) {
    renderInfo = renderInfo.slice(0, sliceInfo);
  }

  return (
    <div className={`${styles.container} ${className}`} style={style}>

      <HideIf show={showTopSeparator}>

        <hr className={styles.horizontalLine} />
      </HideIf>

      <div className={styles.onlydescription}>
        {!descriptions ? description : null}
      </div>

      {h1 && (<div className={styles.headingOfDetails}>{h1}</div>)}
      <div
        className={classnames({
          [styles.grey_color_accordion]: accordionColor === "grey",
          [styles.accordion]: true,
        })}
      >

        {(
          renderInfo.map((attrs, index) => (
            <div
              key={index}
              className={classnames({
                [styles[toKebabCase(tier3)]]: true,
                [styles.eachSpec]: true,
              }, specClassName)}
            >

              <span className={styles.label}>{attrs.label}</span>
              <div className="d-flex">
                <span className={styles.value}>{attrs.value}</span>
                {
                  attrs.hasInfo && (
                    <div className="p-l-5">

                      <Popover
                        component={attrs.hasInfo}
                        placement="left"
                      >

                        <i
                          className={`${styles.infoIcon} fa fa-info-circle more-info`}
                        />
                      </Popover>
                    </div>
                  )
                }
              </div>
            </div>
          ))
        )}
      </div>

    </div>
  );
}

export default ExtendedDescription;
